import _ from 'lodash'

const searchNetwork = phoneNumber => {
  const phoneRemoveSpace = phoneNumber.replace(/\s/g, '')
  const phone = phoneRemoveSpace.replace(/^(.855|855)/, '0').substring(0, 3)

  const smartMobile = ['010', '015', '016', '069', '070', '081', '086', '087', '093', '096', '098']
  const cellCard = [
    '011',
    '012',
    '017',
    '061',
    '076',
    '077',
    '078',
    '079',
    '085',
    '089',
    '092',
    '095',
    '099',
  ]
  const metFone = ['031', '060', '066', '067', '068', '071', '088', '090', '097']
  const seaTel = ['018']
  const qb = ['013', '080', '083', '084']
  const cooTel = ['038']

  if (_.includes(smartMobile, phone)) {
    return '(Smart)'
  }

  if (_.includes(cellCard, phone)) {
    return '(Cellcard)'
  }

  if (_.includes(metFone, phone)) {
    return '(Metfone)'
  }

  if (_.includes(seaTel, phone)) {
    return '(Seatel)'
  }

  if (_.includes(qb, phone)) {
    return '(Qb)'
  }

  if (_.includes(cooTel)) {
    return '(CooTel)'
  }

  return '(Other)'
}

export default {
  searchNetwork,
}



// WEBPACK FOOTER //
// ./src/utils/network.js